<template>
  <!-- Analysis -->
  <div class="whole-page-long">
    <div class="navbar-div" v-if="ValidateReports === 1">
      <Navbar
        analysis="CREATEREPORT"
        :colorTheme="colorTheme"
        :user="user"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>
    <Messages :modal_message="modal_processing_message" />

    <div class="row f-row justify-content-center h-100 scrl90">
      <div class="col col-12 f-row" style="color: var(--textactive)">
        <div class="h-100 d-flex flex-column">
          <div class="row f-row mt-4">
            <div class="col col-1"></div>
            <div class="col col-10 align-self-center">
              <button @click="BlackReports">Back to all entries</button>
            </div>
            <div class="col col-3"></div>
          </div>

          <div class="row f-row mt-3 scrl80 justify-content-center">
            <div
              class="col col-10"
              style="border: 1px solid var(--graylightbackground); background: var(--darkbackground);"
            >
              <br />
              <br />
              <div class="col col-12">
                <div
                  class="col col-12"
                  style="margin: 0 50px 10px;color: var(--textinactive);"
                >
                  <i class="fa fa-user ml-2"></i>&nbsp;{{
                    InfoReport.NameUserCreate
                  }}
                </div>
                <div class="col col-12" style="margin: 0 50px 20px;">
                  <h1 style="color: var(--textactive);">
                    {{ InfoReport.title }}
                  </h1>
                </div>
              </div>
              <br />
              <div class="col col-12">
                <div
                  style="margin: 0 50px 50px;color: var(--textactive);"
                  v-html="InfoReport.text"
                ></div>
              </div>
            </div>
          </div>

          <br />
          <div class="row f-row mt-2 justify-content-center">
            <div
              class="col col-3 ml-1 mr-1"
              v-for="(val, index) in NextReport"
              :key="index"
              style="border: 1px solid var(--graylightbackground); background: var(--darkbackground);"
            >
              <div class="col col-12 text-center mt-3">
                <img
                  to=""
                  tag="img"
                  :src="val.img"
                  style="cursor: pointer;"
                  class="report-image mx-auto d-block"
                  alt=""
                />
              </div>
              <br />
              <div
                class="col col-12 mb-3"
                style="margin-left: 10px; margin-right: -50px; height: 50px"
              >
                {{ val.title }}
              </div>
              <div
                class="col col-12 mb-3"
                style="margin-left: 10px; margin-right: -50px;"
              >
                <hr class="hr-report" />
                <a :href="val.link" style="font-size: 0.9rem">View report</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from "@/_services";
import router from "@/router";
import Messages from "../../components/modals/Messages";
import Navbar from "@/components/Navbar.vue";
import { colorThemeVuex } from "@/_core/_helpers/_helpers";

export default {
  name: "blog",
  components: {
    Messages,
    Navbar
  },
  data() {
    return {
      user: {},
      colorTheme: true, // true = dark, else light
      routerSearch: "",
      ValidateReports: 0,
      InfoReport: {
        pk_id_report: 0,
        title: "",
        summary: "",
        text: "",
        publication_date: "",
        State: "",
        NameUserCreate: "",
        company_name: ""
      },
      NextReport: [],
      modal_processing_message: {
        showModalLoading: true,
        messageModal: "",
        optionsModal: true
      }
    };
  },
  created() {
    this.routerSearch = this.$route.params.id;
    if (
      this.$store.state.user.all !== undefined &&
      this.$store.state.user.all != null &&
      this.$store.state.user.all !== ""
    ) {
      this.user = this.$store.state.user.all.items;
      this.ValidateReports = 1;
    }
    this.getInfoReport();
    this.getNexReport();
    document.title = "View Report | QS";
  },
  watch: {},
  computed: {},
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.overview_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      // saveUserPreferences(this);
    },
    getInfoReport: function() {
      var Search = this.routerSearch.split("_");
      var DataSearch = {
        Title: Search[0],
        ReportId: Search[1],
        Validate: this.ValidateReports
      };
      apiService.InfoReport(DataSearch).then(data => {
        if (data != null || data !== undefined) {
          var response = JSON.parse(data);
          response.map(resp => {
            this.InfoReport.pk_id_report = resp.pk_id_report;
            this.InfoReport.title = resp.title;
            this.InfoReport.summary = resp.summary;
            this.InfoReport.text = resp.text;
            this.InfoReport.publication_date = resp.publication_date;
            this.InfoReport.State = resp.state;
            this.InfoReport.NameUserCreate = resp.NameUserCreate;
            this.InfoReport.company_name = resp.company_name;
          });
        }
      });
    },
    getNexReport: function() {
      var Search = this.routerSearch.split("_");
      var DataNext = {
        ReportId: Search[1],
        Validate: this.ValidateReports
      };
      apiService.NextReport(DataNext).then(data => {
        if (data != null || data !== undefined) {
          var response = JSON.parse(data);
          response.map(resp => {
            this.NextReport.push({
              pk_id_report: resp.pk_id_report,
              link: resp.link,
              img: resp.img,
              title: resp.title
            });
          });
        }
      });
    },
    BlackReports: function() {
      router.push("/reports");
      // if (this.ValidateReports === 0) {
      //   router.push("/reports");
      // } else {
      //   router.push("/markets");
      // }
    }
  }
};
</script>
